import { render, staticRenderFns } from "./FloatingsV2.vue?vue&type=template&id=044cdc18&"
import script from "./FloatingsV2.vue?vue&type=script&lang=js&"
export * from "./FloatingsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports